
import { Component, Prop, Vue, Watch } from "vue-property-decorator"
import { CircularLoader, PullRefresh, Require } from "@coredination/components"

import AssetDetailQuery from "@/graphql/asset/assetdetail.graphql"
import EntityEventSubscription from "@/graphql/subscription/entityevent.graphql"
import { navbar, NavbarOption } from "@/components/NavbarOptions.vue"
import * as cdn from "@coredination/components"
import { User } from "@coredination/common"

@Component({
    apollo: {
        me: cdn.graphql.me,
        asset: {
            query: AssetDetailQuery,
            skip() {
                return !this.uuid
            },
            variables() {
                return { uuid: this.uuid }
            },
        },
        $subscribe: {
            entityEvent: {
                query: EntityEventSubscription,
                result(result: any) {
                    const event = result.data.entityEvent
                    if (
                        event.type == "entityUpdated" &&
                        event.data &&
                        event.data.entityClass == "Asset" &&
                        event.data.uuid == this.model.uuid
                    ) {
                        console.log("asset was updated", event.data)
                        if (this.asset.version >= event.data.version) {
                            console.log("not refreshing - same version")
                        } else {
                            console.log("refreshing")
                            this.refresh()
                        }
                    }
                },
            },
        },
    },
    components: {
        CircularLoader,
        PullRefresh,
        Require,
        StateField: () => import("@/components/fields/StateField.vue"),
        FreeTextField: () => import("@/components/fields/FreeTextField.vue"),
        LabelField: () => import("@/components/fields/LabelField.vue"),
        CustomerField: () => import("@/components/fields/CustomerField.vue"),
        ContactField: () => import("@/components/fields/ContactField.vue"),
        GroupField: () => import("@/components/fields/GroupField.vue"),
        LocationField: () => import("@/components/fields/LocationField.vue"),
        SingleContactField: () => import("@/components/fields/SingleContactField.vue"),
        DocumentsField: () => import("@/components/fields/DocumentsField.vue"),
        CustomFieldsField: () => import("@/components/fields/CustomFieldsField.vue"),
    },
})
export default class AssetView extends Vue {
    @Prop()
    uuid?: string

    asset: any = {}
    refreshing = false
    me?: User

    get fabOptions() {
        return [
            {
                title: this.$t("createNewJob"),
                to: this.jobUrl,
                if: () => this.me && this.me.hasFeature("jobs") && this.me?.hasPermissionInPrimaryGroup("create_jobs") && this.me?.hasPermission("create_jobs")
            },
            {
                title: this.$t("jobFabDocument"),
                click: () => {(this.$refs.documents as any).addDocument()},
                if: () => this.me?.hasGroupPermission(this.asset.groupUuid, "admin_assets"),
            },
            {
                title: this.$t("jobFabTakePhoto"),
                click: () => (this.$refs.documents as any).takePhoto(),
                if: () => this.me?.hasGroupPermission(this.asset.groupUuid, "admin_assets"),
            },
        ]
    }

    get jobUrl() {
        let url = "/job/new";
        const params = [];
        if (this.model.uuid)
            params.push(`asset=${this.model.uuid}`);
        if (this.model.customerUuid)
            params.push(`customer=${this.model.customerUuid}`);
        if (this.model.customerProjectUuid)
            params.push(`customerproject=${this.model.customerProjectUuid}`);
        if (params.length > 0)
            url += `?${params.join("&")}`;
        return url;
    }

    mounted(): void {
        navbar?.setOptions(this.options)
    }

    get options(): NavbarOption[] {
        var options: NavbarOption[] = []
        if (this.asset?.groupUuid && this.me && this.me.hasGroupPermission(this.asset.groupUuid, "admin_assets"))
            options.push({
                icon: "edit",
                title: this.$t("assetOptions_editAsset"),
                to: `/asset/${this.uuid}/edit`,
            })
        return options
    }
    @Watch("me")
    @Watch("asset")
    watchOptions() {
        if (this.me != null) {
            navbar?.setOptions(this.options)
        }
    }

    get loading() {
        return this.refreshing || (this.$apollo.loading && !this.asset.name)
    }

    get model() {
        return this.asset
    }
    set model(updated: any) {
        this.asset = updated
    }

    async refresh() {
        this.refreshing = true
        await this.$apollo.queries.asset.refetch()
        this.refreshing = false
    }

    iosWrapperClient() {
        return Vue.prototype.$iosWrapperClient
    }
}
